import { render } from "./SupplierZones.vue?vue&type=template&id=9e2451ae&ts=true"
import script from "./SupplierZones?vue&type=script&lang=ts"
export * from "./SupplierZones?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__